var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_0_29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5375 8.2875C11.6587 8.40827 11.7549 8.55179 11.8205 8.7098C11.8861 8.86782 11.9199 9.03723 11.9199 9.20833C11.9199 9.37943 11.8861 9.54885 11.8205 9.70686C11.7549 9.86488 11.6587 10.0084 11.5375 10.1292L10.1292 11.5375C10.0084 11.6587 9.86488 11.7549 9.70686 11.8205C9.54885 11.8861 9.37943 11.9199 9.20833 11.9199C9.03723 11.9199 8.86782 11.8861 8.7098 11.8205C8.55179 11.7549 8.40827 11.6587 8.2875 11.5375L1.4625 4.7125C1.21905 4.46787 1.08238 4.13679 1.08238 3.79167C1.08238 3.44654 1.21905 3.11546 1.4625 2.87083L2.87083 1.4625C3.11546 1.21905 3.44654 1.08238 3.79167 1.08238C4.13679 1.08238 4.46787 1.21905 4.7125 1.4625L11.5375 8.2875Z",
    stroke: "#0E3A4C",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.85417 6.77083L8.9375 5.6875",
    stroke: "#0E3A4C",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.22917 5.14583L7.3125 4.0625",
    stroke: "#0E3A4C",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.60417 3.52083L5.6875 2.4375",
    stroke: "#0E3A4C",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.47917 8.39583L10.5625 7.3125",
    stroke: "#0E3A4C",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipment);
export default __webpack_public_path__ + "static/media/shipment.b23b85916b700e3d59e681f3f1a03f86.svg";
export { ForwardRef as ReactComponent };